import { getFormOptions } from "@/api/formoptions";
import FormSelect from "./rcmTableFormItems/Select/index.js";

// 固定欄位屬性
const tableColumnWidth = {
    selection: 32,
    groupName: 180,
    serviceGroupName: 250,
    appProfileName: 250,
    serverName: 250,
    recordLineGroupName: 200,
    createBy: 180,
    createdDate: 200,
    modifiedDate: 200,
    serviceIP: 180,
    connectState: 160,
    ruleName: 180,
    status: 180,
};

let renderSelect = (h, params, parameter) => {
    return h(
        "Select",
        parameter,
        params.column.val[params.index]
            ? params.column.val[params.index]
                  .filter((e) => e != "all")
                  .map((item) => {
                      return h("Option", {
                          props: {
                              value: item.value ? item.value : item,
                              label: item.label ? item.label : item,
                          },
                      });
                  })
            : []
    );
};

let renderInput = (h, params, vm) => {
    return h("Input", {
        props: {
            type: "text",
            value: vm.data[params.index][params.column.key],
        },
        on: {
            "on-change": (event) => {
                vm.data[params.index][params.column.key] = event.target.value;
            },
        },
    });
};

let renderSwitch = (h, params, vm) => {
    return h("i-switch", {
        props: {
            trueColor: "default",
            value: vm.data[params.index][params.column.key] === "true",
            // beforeChange() {},
        },
        on: {
            "on-change": (value) => {
                params.row[params.column.key] = value;
                vm.data[params.index][params.column.key] = value;
            },
        },
    });
};

export default function (vm) {
    return [
        {
            searchViews: ["*"],
            key: "appProfileName",
            minWidth: tableColumnWidth.appProfileName,
            showInTable: true,
            isWatchField: false,
            title: vm.$i18n.t("domainsetting.appProfileName"),
            remoteOptions: async (queryValue, queryParams) => {
                queryValue = queryValue || "*";
                queryParams.appProfileName = `*${queryValue}*`;
                // 選項依參數domainWithNoneAppProfile決定是否回傳none
                queryParams.withNone = vm.$store.getters.getDomainConfig.domainWithNoneAppProfile;
                let queryString = new URLSearchParams(queryParams).toString();
                let result = await getFormOptions(`/app-profilenames?${queryString}`);
                return result.data.options;
            },
            render: (h, params) => {
                if (!vm.data[params.index][params.column.key]) {
                    vm.data[params.index][params.column.key] = "none";
                }
                let parameter = {
                    props: {
                        value: !vm.data[params.index][params.column.key]
                            ? "none"
                            : vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: false,
                        "allow-create": false,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
            // queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
        },
        {
            searchViews: ["*"],
            key: "groupName",
            title: vm.$i18n.t("domainsetting.groupName"),
            minWidth: tableColumnWidth.groupName,
            showInModal: vm.$store.state.queryGroupName == "all",
            showInTable: false,
            isWatchField: false,
            formRender: "FormSelect",
            // fixed: "left",
            label: vm.$i18n.t("domainsetting.groupName"),
            remoteOptions: async (queryValue, queryParams) => {
                queryValue = queryValue || "*";
                queryParams.groupNames = `*${queryValue}*`;
                let queryString = new URLSearchParams(queryParams).toString();
                let result = await getFormOptions(`groupnames?${queryString}`);
                return result.data.options;
            },
            render: (h, params) => {
                let parameter = {
                    props: {
                        value: vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: false,
                        "allow-create": false,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
        },
        {
            searchViews: ["*"],
            key: "servername",
            title: vm.$i18n.t("domainsetting.servername"),
            minWidth: tableColumnWidth.serverName,
            showInTable: true,
            isWatchField: false,
            // fixed: "left",
            render: (h, params) => {
                return renderInput(h, params, vm);
            },
        },
        {
            searchViews: ["*"],
            key: "serviceGroupName",
            minWidth: tableColumnWidth.serviceGroupName,
            showInTable: true,
            isWatchField: true,
            title: vm.$i18n.t("domainsetting.serviceGroupName"),
            remoteOptions: async (queryValue, queryParams) => {
                queryValue = queryValue || "*";
                queryParams.serviceGroupNames = `*${queryValue}*`;
                let queryString = new URLSearchParams(queryParams).toString();
                let result = await getFormOptions(`/servicegroupnames?${queryString}`);
                return result.data.options;
            },
            // watchField: async function ({ value = "", data = "" }) {
            //     return await value.remoteOptions("*", {
            //         groupNames: vm.formItem.groupName.defaultVal,
            //     });
            // },
            render: (h, params) => {
                let parameter = {
                    props: {
                        value: vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: false,
                        "allow-create": false,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
            // queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
        },
        {
            searchViews: ["DomainSetting", "AppProfile", "OriginPolicy", "ProfileDomain"],
            key: "origins",
            title: vm.$i18n.t("domainsetting.origins"),
            minWidth: 200,
            showInTable: true,
            isWatchField: true,
            remoteOptions: async (queryValue, queryParams) => {
                queryValue = queryValue || "*";
                queryParams.origins = `*${queryValue}*`;
                let queryString = new URLSearchParams(queryParams).toString();
                let result = await getFormOptions(`/groupby/origins?${queryString}`);
                return result.data.options;
            },
            render: (h, params) => {
                if (params.column.val[params.index]) {
                    if (!params.column.val[params.index].find((e) => e == vm.data[params.index][params.column.key])) {
                        if (
                            typeof vm.data[params.index][params.column.key] == "string" &&
                            vm.data[params.index][params.column.key] != ""
                        ) {
                            params.column.val[params.index].push(vm.data[params.index][params.column.key]);
                        } else if (vm.data[params.index][params.column.key].length > 0) {
                            params.column.val[params.index].push(vm.data[params.index][params.column.key][0]);
                        }
                    }
                }

                let parameter = {
                    props: {
                        value: vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: true,
                        "allow-create": true,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
            // queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
        },
        {
            searchViews: ["DomainSetting", "AppProfile", "OriginPolicy", "ProfileDomain"],
            key: "originscheme",
            title: vm.$i18n.t("domainsetting.originscheme"),
            minWidth: 150,
            showInTable: true,
            isWatchField: false,
            remoteOptions: () => {
                return ["http", "https", "static"];
            },
            render: (h, params) => {
                let parameter = {
                    props: {
                        value: vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: false,
                        "allow-create": false,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
        },
        {
            searchViews: ["DomainSetting", "AppProfile", "OriginPolicy", "ProfileDomain"],
            key: "portMappingType",
            title: vm.$i18n.t("domainsetting.portMappingType"),
            minWidth: 150,
            showInTable: true,
            isWatchField: false,
            remoteOptions: () => {
                return ["default", "static"];
            },
            render: (h, params) => {
                let parameter = {
                    props: {
                        value: vm.data[params.index][params.column.key],
                        transfer: true,
                        filterable: true,
                        multiple: false,
                        "allow-create": false,
                    },
                    on: {
                        "on-change": async (e) => {
                            params.row[params.column.key] = e;
                            vm.data[params.index][params.column.key] = e;
                        },
                    },
                };
                return renderSelect(h, params, parameter);
            },
        },
        {
            searchViews: ["DomainSetting", "AppProfile", "OriginPolicy", "ProfileDomain"],
            key: "originPort",
            title: vm.$i18n.t("domainsetting.originPort"),
            minWidth: 150,
            showInTable: true,
            isWatchField: false,
            // fixed: "left",
            watchField: async function ({ value = "", data = "" }) {
                let val = data.originscheme;
                let originPort = 443;
                if (val == "http") {
                    originPort = 80;
                }
                return originPort;
            },
            render: (h, params) => {
                return renderInput(h, params, vm);
            },
            queryParamsFields: [{ fieldName: "originscheme", queryIf: (val) => val !== "" }],
        },
    ];
}



// WEBPACK FOOTER //
// ./src/components/ImportFields.js